import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Box, Stack, List, ListItemButton, ListItemText, ListItemIcon } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { connect } from 'react-redux'
import '../styles/SideMenu.scss'
import { themeTopmenu } from '../components/Style'
import config from 'config/config'
import { getTransLang } from '../components/MultiLanguage/dynamic-content-translate'

const SingleMenu = (props) => {
  const location = useLocation()
  const navigate = useNavigate()
  const activeMenu = location.pathname.slice(1).split('/')[0]
  const lang = props.langDetails.currentLanguage

  const translateMenu = (name) => {
    return getTransLang(lang)[name]
  }

  return (
    <ThemeProvider theme={themeTopmenu}>
      <Box>
        <List sx={[config.m0, config.p0, config.liststyle, { borderRight: '1px solid #D6DCDF' }]} component={Stack} direction="row">
          {props?.item?.map((menu, i) => (
                <ListItemButton tabIndex={i + 1} key={menu.route} onClick={() => navigate(`/${menu.route}`)} className={'topMenuLink t-decorate-none'} selected={activeMenu === menu.route} sx={[config.p00]}>
                  <ListItemIcon sx={[config.minW24]}>
                    <img src={menu.icon} alt={menu.altText + ' icon'} height="21" width="21" className="sideMenuTitleImg" />
                  </ListItemIcon>
                  <h1><ListItemText primary={translateMenu(menu.name)} /></h1>
                </ListItemButton>
          ))}
        </List>
      </Box>
    </ThemeProvider>
  )
}

const mapStateToProps = (state) => ({
  langDetails: state.language
})

export default connect(mapStateToProps, null)(SingleMenu)
